import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { StyledButton as Button } from '../../../common/Button'
import { BlockGroupingOptionsContainer } from './BlockOptionsContainers'
import { withTranslation } from 'react-i18next'
import { Menu } from '../../../common/Menu'

export const BlockGroupingOptions = ({ count, grouped, group, ungroup, t }) => {
  return (
    <Fragment>
      <Menu.Divider />
      {grouped ? (
        <Button onClick={ungroup}>{t('blockOptions.ungroup')}</Button>
      ) : (
        <Button onClick={group}>{t('blockOptions.group')}</Button>
      )}
    </Fragment>
  )
}

BlockGroupingOptions.propTypes = {
  count: PropTypes.number.isRequired,
  grouped: PropTypes.bool,
  group: PropTypes.func.isRequired,
  ungroup: PropTypes.func.isRequired
}

export default BlockGroupingOptionsContainer(withTranslation()(BlockGroupingOptions))
